<template>
    <div class="home">

      
        <div class="content" v-if="tabIndex==0">
            <div class="left-box">
                <div class="title">
                    <div class="title-big">公园简介</div>
                </div>
                <!-- <div class="detail">
                    <div class="detail-item">
                        广州市流溪河国家森林公园位于广州市郊从化东北部，是经林业部批准建立的首批国家十大森林公园之一，总面积8932.31公顷。在碧波万倾的流溪湖面上，分布着大小二十二个岛屿，如白玉翡翠。公园的东南部，耸立着五指山、鸡枕山等山峰起伏连绵、重峦叠嶂，大有“远山时明灭”、“高峡出平湖”的气势。这里地处亚热带，园内四季常青、风光如画：春时百花吐艳、漫山锦绣；夏天雨水充沛，有高山“银流泻玉珠”之景；秋季金风送爽、枫叶红似火；冬日梅林飘香，有“流溪香雪”之美称。流溪河国家森林公园集人文景观、森林保健功能于一体。有水上游乐、与猴同乐、民族风情园、户外拓展等10多个游乐项目，建立流溪香雪、流溪彩虹、珍稀植物园等12个人文景观，开辟三桠塘幽谷、小漓江、翡翠群岛、湖滨栈道、流溪绿道等15处自然景观。在碧波万倾的流溪湖面上，分布着大小22个岛屿，如白玉翡翠。这里地处亚热带，四季常青、风光如画:春时百花吐艳、漫山锦绣;夏天雨水充沛，有高山“银流泻玉珠”之景;秋季金风送爽、枫叶红似火;冬日梅林飘香，有“流溪香雪之美称，是为“流溪湖景区”。
                        
                    </div>
                </div> -->
                <div class="detail">
                    <div class="detail-item-img">
                        <img src="../../assets/imgs/all/xuanchuan.png" class="img-detail" alt="">
                        
                    </div>
                </div>
                <!-- <div class="checkMore">
                    <div class="line-box">
                            <div class="line"></div>
                            <div class="radio"></div>
                    </div>
                    <div>查看更多</div>
                </div> -->
            </div>
            <div class="right-box">
                <video src="https://qiniu.cxtrip.cc/lxhvideo202305.mp4" style="width: 100%; height: 100%; object-fit: fill" controls="true" class="video"></video>
            </div>
            <div class="left-footer">
                <div class="line-box"><div class="line"></div></div>
                <p class="text">备案号 </p><p class="num">粤ICP备18151363号-1</p>
                <div class="line-box"><div class="line"></div></div>
            </div>
        </div>
        <div class="content" v-if="tabIndex==1">
            <div class="public">
                <div class="public-tab cs">
                    <div class="public-tab-item">
                        <div :class="[publicIndex==0?'text text-act':'text']" @click="changePublicIndex(0)">政务新闻</div>
                        <div v-if="publicIndex==0" class="botLine"></div>
                    </div>
                    <div class="public-tab-item">
                        <div :class="[publicIndex==1?'text text-act':'text']" @click="changePublicIndex(1)">荣誉证书</div>
                        <div v-if="publicIndex==1" class="botLine"></div>
                    </div>
                </div>
                <div class="public-detail" v-if="publicIndex==0">
                    <!-- <div v-if="publicDetail==false" class="public-detail-item cs" v-for="(item,index) in list" :class="[index==2?'bn list-item' :'list-item']" @click="getPublicDetailItem(item,index)">
                        <div class="time wh">{{fliterTime(item.insert_date_time)}}</div>
                        <img :src="item.head_url" class="img" alt="">
                        <div class="text-detail">
                            <div class="text-detail-title">{{item.news_name}}</div>
                            <div class="text-detail-content">{{item.detail}}</div>
                        </div>
                       
                    </div> -->
                    <div v-if="publicDetail==false" class="public-detail-item cs" v-for="(item,index) in list" :class="[index==2?'bn list-item' :'list-item']" @click="getPublicDetailItem(item,index)">
                        <div class="time wh">{{item.time}}</div>
                        <img :src="item.img" class="img" alt="">
                        <div class="text-detail">
                            <div class="text-detail-title">{{item.title}}</div>
                            <div class="text-detail-content">{{item.detail}}</div>
                        </div>
                       
                    </div>

                  <div class="publicDetail" v-if="publicDetail">
                        <div class="title">
                            <div>{{publicItem.title}}</div>
                            <div style="margin: 10px 0;" v-if="publicItem.subTitle">{{publicItem.subTitle}}</div>
                            <div class="left-return cs" @click="returnList">
                                <img  src="../../assets/images/left.png" alt="" class="img">
                                <div class="cs">返回列表</div>
                            </div>
                        </div>
                        
                        <div class="time">{{publicItem.time}}</div>
                        <div class="flex-box-clumo"  v-if="publicItem.url">
                            <div class="text-msg" v-for="item in publicItem.url"><a target="_blank" style="color:#fff;" :href="item.url">{{ item.name }}</a></div>

                        </div>
                        <div class="text-msg" v-else style="font-size: 19px">{{publicItem.detail}}</div>
                        

                        
                        
                        <div class="text-msg" style="margin-top:0;font-size: 19px">{{publicItem.firstPart}}</div>
                        <div class="text-msg" style="margin-top:0;font-size: 19px">{{publicItem.secPart}}</div>
                        <div class="text-msg" style="margin-top:0;font-size: 19px">{{publicItem.thrPart}}</div>
                        <div class="text-msg" style="margin-top:0;font-size: 19px">{{publicItem.fourPart}}</div>
                        <div class="text-msg" style="margin-top:0;font-size: 19px">{{publicItem.fivePart}}</div>
                    </div>
                    <!-- <div class="publicDetail" v-if="publicDetail&&publicItemIndex==0">
                        <div class="title">
                            <div class="left-return cs" @click="returnList">
                                <img  src="../../assets/images/left.png" alt="" class="img">
                                <div class="cs">返回列表</div>
                            </div>
                        </div>
                        <div class="publicDetail-img"><img  src="https://qiniu.cxtrip.cc/tupian_2a2001c0a20ddbd76603b59ab.png" class="img" alt=""></div>
                        
                    </div> -->
                    <!-- <div class="publicDetail" v-if="publicDetail">
                                <div class="title">
                                    <div>{{publicItem.news_name}}</div>
                                    <div style="margin: 10px 0;" v-if="publicItem.subTitle">{{publicItem.subTitle}}</div>
                                    <div class="left-return cs" @click="returnList">
                                        <img  src="../../assets/images/left.png" alt="" class="img">
                                        <div class="cs">返回列表</div>
                                    </div>
                                </div>
                                
                                <div class="time">{{fliterTime(publicItem.insert_date_time)}}</div>
                                <div class="flex-box-clumo"  v-if="publicItem.attachment_url">
                                    <div class="text-msg" ><a target="_blank" style="color:#fff;" :href="publicItem.attachment_url">{{ publicItem.news_name }}</a></div>

                                </div>
                                <div >
                                    <iframe :src="publicItem.detail_url" frameborder="0" width="80%" height="400px" style="margin-left: 20%;"></iframe>
                                </div>
                    </div> -->
                    <!--<div class="publicDetail" v-if="publicDetail&&publicItemIndex==0">
                        <div class="title">
                            <div class="left-return cs" @click="returnList">
                                <img  src="../../assets/images/left.png" alt="" class="img">
                                <div class="cs">返回列表</div>
                            </div>
                        </div>
                        <div class="publicDetail-img"><img  src="https://qiniu.cxtrip.cc/tupian_2a2001c0a20ddbd76603b59ab.png" class="img" alt=""></div>
                        
                    </div> -->
                </div>
                <div class="honor-box" v-if="publicIndex==1">
                    <div class="img-box">
                        <img src="../../assets/honor/honer1.jpg" class="img" alt="">
                        <img src="../../assets/honor/honer2.jpg" class="img" alt="">
                        <img src="../../assets/honor/honer3.jpg" class="img" alt="">
                        <img src="../../assets/honor/honer4.jpg" class="img" alt="">
                        <img src="../../assets/honor/honer5.jpg" class="img" alt="">
                        <img src="../../assets/honor/honer6.jpg" class="img" alt="">
                        <img src="../../assets/honor/honer7.jpg" class="img" alt="">
                        <img src="../../assets/honor/honer8.jpg" class="img" alt="">
                        <img src="../../assets/honor/honer9.jpg" class="img" alt="">
                        <img src="../../assets/honor/honer10.jpg" class="img" alt="">
                        <img src="../../assets/honor/honer11.jpg" class="img" alt="">
                        <img src="../../assets/honor/honer12.jpg" class="img" alt="">
                        <img src="../../assets/honor/honer13.jpg" class="img" alt="">
                        <img src="../../assets/honor/honer14.jpg" class="img" alt="">
                        <img src="../../assets/honor/honer15.jpg" class="img" alt="">
                        <img src="../../assets/honor/honer7.jpg" class="img" alt="">
                        <img src="../../assets/honor/honer16.jpg" class="img" alt="">
                        <img src="../../assets/honor/honer17.jpg" class="img" alt="">
                        <img src="../../assets/honor/honer18.jpg" class="img" alt="">
                        <img src="../../assets/honor/honer19.jpg" class="img" alt="">
                    </div>
                </div>
            </div>
        </div>
        <div class="content" v-if="tabIndex==2">
      
            <div class="left-footer">
                <div class="line-box"><div class="line"></div></div>
                <p class="text">备案号</p><p class="num">12313215</p>
                <div class="line-box"><div class="line"></div></div>
            </div>
            <div class="center-box">
                <div class="center-left">
                        <div class="title">
                            <div class="title-sm">Scenic Area Dynamics</div>
                            <div class="title-big">景区动态</div>
                        </div>
                        <div class="btn-list cs">
                            <div :class="[listIndex==0? 'act btn-item' : 'btn-item']" @click="changeListIndex(0)">景区新闻</div>
                            <div :class="[listIndex==1? 'act btn-item' : 'btn-item']" @click="changeListIndex(1)">景区活动</div>
                            <div :class="[listIndex==3? 'act btn-item' : 'btn-item']" @click="changeListIndex(3)">基地介绍</div>
                            <!-- <div :class="[listIndex==2? 'act btn-item' : 'btn-item']" @click="changeListIndex(2)">景区公告</div> -->
                        </div>
                </div>
                <div class="center-right" v-if="showDetail==false">

                    <div class="center-right-list cs scrollable-container" v-if="listIndex==0">
                        <div v-for="(item,index) in list2" :class="[index==2?'bn list-item' :'list-item']" @click="getDetailItem(item)">
                            <img :src="item.img" alt="" class="img">
                            <div class="text-value">
                                <div class="text-title">
                                    <div class="name">{{item.title}}</div>
                                    <div class="time">{{item.time}}</div>
                                </div>
                                <div class="text-detail">
                                   <p>{{item.detail}}</p> 
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- <div class="checkMore" v-if="listIndex==0">
                        <div>查看更多</div>
                        <div class="line-box">
                            <div class="radio"></div>
                            <div class="line"></div>
                        </div>
                    </div> -->
                    <div class="center-right-list cs" v-if="listIndex==1">
                            <div v-for="(item,index) in activeList" :class="[index==2?'bn list-item' :'list-item']" @click="getDetailItem(item)">
                                <img :src="item.img" alt="" class="img">
                                <div class="text-value">
                                    <div class="text-title">
                                        <div class="name">{{item.title}}</div>
                                        <div class="time">{{item.time}}</div>
                                    </div>
                                    <div class="text-detail">
                                       {{item.detail}}
                                    </div>
                                </div>
                            </div>
                    </div>
                    <div class="center-right-list cs" v-if="listIndex==3">
                            <div v-for="(item,index) in jidiList" :class="[index==2?'bn list-item' :'list-item']" @click="getDetailItem(item)">
                                <img :src="item.img" alt="" class="img">
                                <div class="text-value">
                                    <div class="text-title">
                                        <div class="name">{{item.title}}</div>
                                        <div class="time">{{item.time}}</div>
                                    </div>

                                    <div class="text-detail">
                                       <p>{{item.detail}}</p> 
                                    </div>
                                </div>
                            </div>
                    </div>
                    <div class="center-right-list" v-if="listIndex==2">
                        <div class="center-right-title">广州市流溪河国家森林公园游园守则</div>
                        <div class="center-right-detail">一、公园开放时间:8:00-17:00 </div>
                        <div class="center-right-detail">二、游客未经允许不得在非开放时间进园及逗留。学龄前儿童进入公园需成年人陪同。
                        <div class="center-right-detail">三、文明旅游爱护花草树木，不得采摘、挖植物，踩踏花草，攀爬树木、景石，捕捉野生动物。</div>
                        <div class="center-right-detail">四、爱护公共设施，不得在公共设施及植物上乱涂写、刻画、张挂物品。</div>
                        <div class="center-right-detail">五、文明游园，不得随意吐痰、便溺，烟头、果皮、纸皮等废置物请按规定投入垃圾分类箱。不得在亭、廊、坐椅、护栏上踩踏、躺卧。</div>
                        <div class="center-right-detail">六、未经公园管理机构批准，不得在公园区域内营火、烧烤、垂钓、露营及放风筝。</div>
                        <div class="center-right-detail">七、严禁搭乘无证、无牌船只游览湖。</div>
                        <div class="center-right-detail">八、禁止携带一切火种、管制刀具进园，禁止携带氢气球等易燃易爆危险品进园，禁止携带宠物进园九、禁止在园内从事黄、赌、毒等违法犯罪活动，禁止非法集会、闹事，打架斗殴。</div>
                        <div class="center-right-detail">十、车辆未经允许不得进园。</div>
                        <div class="center-right-detail">游客如有违反以上游园守则的，公园管理部门将依照《广州市公园管理条例》进行处罚如需咨询，请致电:020-87843288</div>
                    </div>
                    </div>
                </div>
                <div class="center-box-detail" v-if="showDetail&&listIndex!==3">
                    <div class="title">
                        <div>{{detailItem.title}}</div>
                        <div class="left-return cs" @click="returnList">
                            <img  src="../../assets/images/left.png" alt="" class="img">
                            <div class="cs">返回列表</div>
                        </div>
                    </div>
                    <div class="time">{{detailItem.time}}{{detailItem.timeDetail?detailItem.timeDetail:''}}</div>
                    <div class="scroll-box">
                        <div class="img-box" v-if="!detailItem.detail_url">
                            <img class="img" :src="item2" v-for="item2 in detailItem.imgList">
                        </div>
                        <div v-if="!detailItem.detail_url" class="text-msg">{{detailItem.detail}}</div></div>
                        <div >
                            <iframe :src="detailItem.detail_url" frameborder="0" width="100%" height="400px"></iframe>
                        </div>
                </div>
                <div class="center-box-detail" v-if="showDetail&&listIndex==3">
                        <div class="title">
                            <div>{{detailItem.title}}</div>
                            <div class="left-return cs" @click="returnList">
                                <img  src="../../assets/images/left.png" alt="" class="img">
                                <div class="cs">返回列表</div>
                            </div>
                        </div>
                        <div class="time">{{detailItem.time}} </div>
                        <div class="img-box">
                            <img class="img" :src="item2" v-for="item2 in detailItem.imgList">
                        </div>

                        <div class="text-msg2">{{detailItem.detail}}</div>
                 
                </div>
            </div>
        </div>
        <div class="content" v-if="tabIndex==3">
            <div class="center-box2">
                <div class="center-right">
                    <div class="title-box">
                    
                        <div class="tab-box cs">
                            <div  :class="[ticketIndex===0? 'tab-item-act tab-item' : 'tab-item']" @click="changeTicketIndex(0)">
                                交通指引
                                <div v-if="ticketIndex==0" class="botLine"></div>
                            </div>
                            <div :class="[ticketIndex===1? 'tab-item-act tab-item' : 'tab-item']" @click="changeTicketIndex(1)">
                                景区导览
                                <div v-if="ticketIndex==1" class="botLine"></div>
                            </div>
                        </div>
                    </div>
                    <div class="detail-box" v-if="ticketIndex==0">
                        <div class="guaide">
                            <div class="item">班车:</div>
                            <div class="em item">
                                    在广州市汽车站(省站对面)、广源客运站、东四客远站乘广州到从化街口专线车到达从化客运站，再转乘街口至森林公园空调大巴前往。或者在东此坐车到从化客运站，从化客运站坐到良口的车，上车的时候跟司机说你是去流溪河森林公园，他会放你下车。
                            </div>
                            <div class="item">自驾车线路:</div>
                            <div class="item">自驾车线路1:广州出发进入机场高速或京珠高速再进入街北高速，至从化出口再进入105国道直走约35公里，转入“流溪香雪”景区 (不需进入森林公是总部)。</div>
                            <div class="item">自驾车线路2:由广园中路进入白云大道再进入新广从公路(105国道直走约93公里，转入“流溪香雪”景区不需进入森林公园总部)流溪河国家森林公园位于广东省繁华大都市广州市北部的从化市郊，距广州市中心93公里，105国道贯穿公园，交通方便。</div>
                            <div class="item">自驾车从广州出发—华南快速—京港澳高速—街北高速大广高速到达良口站下—105国道—然后走观湖路即可到达。</div>
                            <div class="item">坐车从广州出发，可到广州市郊县汽车站(省站对面)乘601专线车或到广源客运站、东国客运站、越秀南客运站乘广州—从化街口专线车，到达从化客运站后转乘街口—森林公园空调大巴直达公园门口</div>
                            <div class="item">自驾游:</div>
                            <div class="item">佛山出发—广佛高速—机场高速—街北高速—北环高速—华南三期—大广高速—到达良口站下—105道—然后走观湖路即可到达</div>
                            <div class="item">中山出发—深罗高速—广澳高速—南沙港快速—广州环城高速—华南快速—京港澳高速—街北高速—大广高速—到达良口站下—105国然后走观湖路即可到达</div>  
                            <div class="item">深圳出发—莞深高速—增从高速—大广高速—到达良口站下—105国道然后走观湖路即可到达</div>
                            <div class="item">东莞出发—莞深高速—增从高速—大广高速—到达良口站下—105国道然后走观湖路即可到达</div> 
                                
                        </div>
                        <!-- <div class="ticket-list">
                            <div class="ticket-list-item">
                                <div class="img1">
                                    <img class="img" src="../../assets/images/top.png">
                                    <div>购票信息</div>
                                </div>
                                <div class="list-text-box">
                                    <div class="text1">在购票过程中如有疑问，拔打24小时服务热线： 020-x0xxxxx1"</div>
                                    <div class="text2">里是购票说明这里是购票说明这里是购票说明这里是购票说明这里是购票说明这里是购票说明这里是购菜说明这重是购菜说明这里是购票说明这里是购索说明这单是购菜说明这里是购票说明这重是购票说明这里是购票说明这里是购票说明这里是购票说明这里是购票说明这里…</div>
                                </div>
                            </div>
                            <div class="ticket-list-item">
                                    <div class="img2">
                                        <img class="img" src="../../assets/images/bottom.png">
                                        <div>优惠政策</div>
                                    </div>
                                    <div class="list-text-box">
                                        <div class="text1">适用于流溪湖景区、五指山景区</div>
                                        <div class="text2">里是购票说明这里是购票说明这里是购票说明这里是购票说明这里是购票说明这里是购票说明这里是购菜说明这重是购菜说明这里是购票说明这里是购索说明这单是购菜说明这里是购票说明这重是购票说明这里是购票说明这里是购票说明这里是购票说明这里是购票说明这里…</div>
                                    </div>
                            </div>
                        </div> -->
                    </div>
                    <div class="detail-box" v-if="ticketIndex==1">
                            <!-- <div class="img-box">
                                <div class="tab-head cs">
                                    <div :class="[checkTabIndex===0? 'tab-item-act tab-item' : 'tab-item']"  @click="checkTabIndex=0">流溪河景区</div>
                                    <div :class="[checkTabIndex===1? 'tab-item-act tab-item' : 'tab-item']"  @click="checkTabIndex=1">五指山景区</div>
                                </div>
                                
                                <img v-if="checkTabIndex==0" src="../../assets/images/map.png" alt="" class="img">
                                <img v-if="checkTabIndex==1" src="../../assets/images/map2.png" alt="" class="img">
                            </div> -->
                            <div class="big-img-box">
                                <img src="https://qiniu.cxtrip.cc/liuxihe/daoyoudaolan.png" alt="" class="img">
                                <div class="event" @mousemove="handler" @mouseout="handlerOver"></div>
                                <div class="big">
                                    <img src="https://qiniu.cxtrip.cc/liuxihe/daoyoudaolan.png" ref="big" />
                                </div>
                                <div class="mask" ref="mask" v-if="showMask"></div>
                            </div>
                
                        </div>
                </div>
                <div class="center-left" v-if="ticketIndex==1">
                    <img src="../../assets/images/ewm.jpg" alt="" class="code-img">
                    <div>扫码预览</div>
                </div>

            </div>
        </div>
        <div class="content" v-if="tabIndex==4">
            <div class="center-box2" style="padding-left: 80px;">
                <div class="center-right">
                        <div class="title-box">
                            <div class="tab-box cs">
                                <div  :class="[yuyueIndex===0? 'tab-item-act tab-item' : 'tab-item']" @click="changeYuyueIndex(0)">
                                    价目表
                                    <div v-if="yuyueIndex==0" class="botLine"></div>
                                </div>
                                <div :class="[yuyueIndex===1? 'tab-item-act tab-item' : 'tab-item']" @click="changeYuyueIndex(1)">
                                    门票优惠政策
                                    <div v-if="yuyueIndex==1" class="botLine"></div>
                                </div>
                                <div :class="[yuyueIndex===2? 'tab-item-act tab-item' : 'tab-item']" @click="changeYuyueIndex(2)">
                                    游园守则    
                                    <div v-if="yuyueIndex==2" class="botLine"></div>
                                </div>
                            </div>
                        </div>
                        <div class="table-box" v-if="yuyueIndex==0">
                            <div class="table">
                                <div class="table-item bb">
                                    <div class="name br">项目名称</div>
                                    <div class="type br">类型</div>
                                    <div class="price br">票价</div>
                                    <div class="common">收费依据</div>
                                </div>
                                <div class="table-item2 bb">
                                    <div class="name br"><div class="l32">流溪湖景区门票</div></div>
                                    <div class="type br"><div class="type-item bb">全票</div><div class="type-item">半票</div></div>
                                    <div class="price br"><div class="price-item bb">40元/人</div><div class="price-item">20元/人</div></div>
                                    <div class="common"><div class="l32">从发改函</div><div>[2011]151号</div></div>
                                </div>
                                <div class="table-item2">
                                        <div class="name br"><div class="l32">五指山景区门票</div></div>
                                        <div class="type br"><div class="type-item bb">全票</div><div class="type-item">半票</div></div>
                                        <div class="price br"><div class="price-item bb">40元/人</div><div class="price-item">20元/人</div></div>
                                        <div class="common"><div class="l32">从发改函</div><div>[2009]20号</div></div>
                                </div>
                            </div>
                            <div class="notice">
                                <div class="notice-title">购票须知</div>
                                   <div class="l30"> 1、门票官方渠道为:微信小程序(右侧扫码购票)》，现场窗口购票</div>
                                   <div class="l30"> 2、购票前请了解景区情况，一经售出，恕不退票；特殊情况退票，请到游客中心窗口咨询。</div>
                                   <div class="l30">3、为了您的安全，请在公园营业时间内游览(现场售取票时间: 5-10月:08:30-17:00/11-4月: 08:30-17:30)，景区开放时间:5-10月: 08:30-19:00/11-4月: 08:30-18:00)</div> 
                                   <div class="l30">4、请勿采食野生蘑菇;勿在溪流戏水，禁止在山塘水库游泳，禁止携带火种进园;禁止使用滑板、轮滑鞋等滑行工具;禁止携带宠物入园。</div> 
                                   <div class="l30">价格举报电话: 12315,12345 景区投诉电话: 020-87843288</div> 
                                </div>
                        </div>
                        <div class="prefer-box" v-if="yuyueIndex==1">
                            <div class="l38">1、本景区门票仅限一次性检票入园使用。</div>
                            <div class="l38">2、对6周岁(含6周岁)以下或身高1.2米(含1.2米)以下的儿童实行免票;65周岁(含65周岁)以上的老人、残疾人、现役军人、退役军人、军队离退休干部、本市户籍的退役军人、退休士官、现役武警部队官兵、现役军人家属、烈士遗属、因公牺牲军人遗属、病故军人遗属、(在职、退休)消防救援人员、消防救援院学员和享受国家定期抚恤补助的优抚对象以及民政部门确认的低保救助对象、五保户;持广州市无偿献血优待证(A)、(B)、(C)人员凭有效证件实行免票。</div>
                            <div class="l38">3、1.2米(不含1.2米)至1.5米(含1.5米)的儿童半票;6周岁(不含6周岁)至18周岁(含18周岁)未成年人、60周岁(含60周岁)至64周岁(含64周岁)的老年人、全日制大专本科及以下学历的学生凭有效证件半票，盲人、智力残疾人、双下肢残疾人和其他重度残疾人，可有一名陪护人员半票</div>
                        </div>
                        <div class="rule-box" v-if="yuyueIndex==2">
                            <div class="l38">一、公园开放时间:8:00-17:00</div>
                            <div class="l38">二、游客未经允许不得在非开放时间进园及逗留。学龄前儿童进入公园需成年人陪同。</div>
                            <div class="l38">三、文明旅游爱护花草树木，不得采摘、挖植物，踩踏花草，攀爬树木、景石，捕捉野生动物。</div>
                            <div class="l38">四、爱护公共设施，不得在公共设施及植物上乱涂写、刻画、张挂物品。</div>
                            <div class="l38">五、文明游园，不得随意吐痰、便溺，烟头、果皮、纸皮等废置物请按规定投入垃圾分类箱。不得在亭、廊、坐椅、护栏上踩踏、躺卧。</div>
                            <div class="l38">六、未经公园管理机构批准，不得在公园区域内营火、烧烤、垂钓、露营及放风筝。</div>
                            <div class="l38">七、严禁搭乘无证、无牌船只游览湖。</div>
                            <div class="l38">八、禁止携带一切火种、管制刀具进园，禁止携带氢气球等易燃易爆危险品进园，禁止携带宠物进园</div>
                            <div class="l38">九、禁止在园内从事黄、赌、毒等违法犯罪活动，禁止非法集会、闹事，打架斗殴。</div>
                            <div class="l38">十、车辆未经允许不得进园。</div>
                            <div class="l38">游客如有违反以上游园守则的，公园管理部门将依照《广州市公园管理条例》进行处罚如需咨询，请致电:020-87843288</div>
                        </div>

                </div>
                <div class="center-left">
                    <div class="ewm-box">
                        <img src="../../assets/images/ewm.jpg" alt="" class="ewm">
                        <div>小程序购票更优惠</div>
                    </div>
                    <div class="ewm-box">
                        <img src="../../assets/images/gzh.jpg" alt="" class="ewm">
                        <div>流溪河官方微信</div>
                    </div>
                </div>
            </div>
        </div>
        <div class="top-fix">
            <div class="logo">
                <img src="../../assets/images/logo2.png" alt="" class="img">
            </div>
            <div class="menu-list" v-if="(currentIndex==0||currentIndex==1||currentIndex==4)">
                <div :class="[tabIndex==0? 'act index' : 'index']" @click="changeIndex(0)">{{$t("index")}}</div>
                <div :class="[tabIndex==1? 'act index' : 'index']" @click="changeIndex(1)">{{$t("public")}}</div>
                <div :class="[tabIndex==2? 'act index' : 'index']" @click="changeIndex(2)">{{$t("trends")}}</div>
                <div :class="[tabIndex==3? 'act index' : 'index']" @click="changeIndex(3)">{{$t("server")}}</div>
                <div :class="[tabIndex==4? 'act index' : 'index']" @click="changeIndex(4)">{{$t("ticketing")}}</div>
            </div>
            <div class="menu-list white" v-if="currentIndex==3||currentIndex==2">
                    <div :class="[tabIndex==0? 'act index' : 'index']" @click="changeIndex(0)">{{$t("index")}}</div>
                    <div :class="[tabIndex==1? 'act index' : 'index']" @click="changeIndex(1)">{{$t("public")}}</div>
                    <div :class="[tabIndex==2? 'act index' : 'index']" @click="changeIndex(2)">{{$t("trends")}}</div>
                    <div :class="[tabIndex==3? 'act index' : 'index']" @click="changeIndex(3)">{{$t("server")}}</div>
                    <div :class="[tabIndex==4? 'act index' : 'index']" @click="changeIndex(4)">{{$t("ticketing")}}</div>
            </div>
        </div>
        <div class="bot-box" style="width:100%;align-content: center; height: 0.925rem;"><span id="_ideConac" style="display: inline-block; height: 10px;width: 10px;margin-left: 38%;"></span></div>
        <Swiper2 @custom-click="handleClick" ref="mySwiper" />

        <!-- 统计代码 -->
        <div class="bot-box">
            <!-- <div></div> -->
            <div class="language">
                <div :class="[lang=='zh'? 'act item' : 'item']" @click="changeLanguage('zh')">中文</div>
                <div :class="[lang=='en'? 'act item' : 'item']" @click="changeLanguage('en')">English</div>
                <div :class="[lang=='jp'? 'act item' : 'item']" @click="changeLanguage('jp')">日本語</div>
                <div :class="[lang=='kr'? 'act item' : 'item']" @click="changeLanguage('kr')">한국어</div>
            </div>
        </div>
        <!-- 在 </div> 之前添加统计代码区域 -->
        <!-- <div class="statistics-fixed">
            <div class="footer-statistics">
                <span id="_ideConac"></span>
            </div>
        </div> -->
    </div>
</template>
<script>
//http://www.lxhpark.cn/upload/402880e750ef74f90150ef75ea6e0003/fd27a9e5e3a74d5b97a5efd93ee310af.jpg
import Header from "./component/header";
import Slogan from "./component/slogan";
import Swiper2 from "./component/swiper2";
import Part from "./part";
import { setup } from "../../utils/locales/index";
import ScenicNewsData from "@/newsData/scenicNewsData";
import GovernmentAffairsNewsData from "@/newsData/governmentAffairsNewsData";
import activeList from "@/newsData/activeList";
import { get } from "@/utils/request";
var  index = 'https://qiniu.cxtrip.cc/liuxihe/index.jpg'
var  index2 = 'https://qiniu.cxtrip.cc/liuxihe/index2.jpg'
var  index3 = 'https://qiniu.cxtrip.cc/liuxihe/index3.jpg'
var  index4 = 'https://qiniu.cxtrip.cc/liuxihe/index4.jpg'
var  index5 = 'https://qiniu.cxtrip.cc/liuxihe/index5.jpg'
export default {
    components: {
        Header,
        Slogan,
        Part,
        Swiper2
    },
    computed: {
        swiper() {
        return this.$refs.mySwiper.swiper;
        }
    },
    data() {
        return {
          showMask:false,
          listIndex:0,
          tabIndex:0,
          checkTabIndex:0,
          ticketIndex:0,
          yuyueIndex:0,
          publicIndex:0,
          currentIndex:0,
          lang:'zh',
          imgArr:[
                {	id:0,
                    url:index,
                },{
                    id:1,
                    url:index2,
                },{
                    id:2,
                    url:index3,
                },{
                    id:3,
                    url:index4,
                },{
                    id:4,
                    url:index5,
                },
        ],
        detail_url:'https://res.gbhui.com/images/commodity/430802/undefined/43000010830/117825979527228E0CA1D968DCE06609.JPG',
        list: GovernmentAffairsNewsData.list,
        list2: ScenicNewsData.list2,
        wordList: [],
        partyList: [],
        lawList: [],
        newsDetail: {},
        travelList: [],
        consultingList: [],
        noticeList: [],
        activeList: activeList.activeList,
          showDetail:false,//显示列表详情  
          publicDetail:false,
          publicItem:{},
          publicItemIndex:0
        }
    },
    mounted () {
       // 动态加载统计脚本
       const script = document.createElement('script');
       script.src = 'https://dcs.conac.cn/js/nis/44/01/00/96db5df934123dacae314886c9243684/12440100455350971U-20018867.js';
       script.type = 'text/javascript';
       document.body.appendChild(script);
    },
    methods: {
        //组件切换
        changeIndex (index) {
            this.tabIndex = index;
            this.showDetail = false;
            if(index==1){
                //this.getNews(1)
            }
        },
        async getNews(type) {
        // 1、公园工作 2、党政信息 3、法律法规 4、旅游动态 5、新闻资讯 6、旅游公告
        const typeListMap = {
            1: "wordList",
            2: "partyList",
            3: "lawList",
            4: "travelList",
            5: "consultingList",
            6: "noticeList",
        };

        // 获取当前类型对应的列表名称
        const listName = typeListMap[type];

        // 如果没有找到对应的列表，或类型无效，则直接返回
        if (!listName) return;

        // 检查对应列表是否已有数据，有则直接返回
        if (this[listName].length > 0) return;

        // 语言映射
        const langMap = {
            zh: 1,
            en: 2,
            ja: 3,
            ko: 4,
        };

        // 获取当前语言类型
        const langType = langMap[localStorage.getItem("lang")] || 1; // 默认为中文

        // 发起请求
        try {
            const res = await get("web/newsList", { type, langType });

            // 将结果存入对应列表
            if (res && res.list) {
            this[listName] = res.list;
            }
            this.list = res.list;
        } catch (error) {
            console.error(`获取${listName}失败:`, error);
            // 可以添加错误处理，比如显示错误提示等
        }
        },
        //列表切换
        changeListIndex (index) {
            this.showDetail = false;
            this.listIndex = index
        },
                //列表切换
        changePublicIndex (index) {
            this.publicIndex = index
        },
        //语言切换
        changeLanguage(lang) {
        　  this.$i18n.locale = lang
            this.lang = lang;
　　        setup(lang);
    　　    //location.reload() // 为了重新实例化vue-router对象，避免一些bug
        },
        changeTicketIndex (idx) {
            console.log(idx)
            this.ticketIndex = idx;
        },
        //预约购票切换
        changeYuyueIndex (idx) {
            console.log(idx)
            this.yuyueIndex = idx;
        },
        getDetailItem (item) {
            console.log(item)
            this.detailItem = item;
            this.showDetail = true;
        },
        getPublicDetailItem (item,index) {
            this.publicItem = item;
            this.publicItemIndex = index;
            this.publicDetail = true;
        },
        //返回列表
        returnList () {
            this.showDetail = false;
            this.publicDetail = false;
        },
        fliterTime (value) {
            return value.slice(0,4)+'年'+value.slice(4,6)+'月'+value.slice(6,8)+'日'+value.slice(8,10)+':'+value.slice(10,12)+':'+value.slice(12,14)
        },
        //父组件方法
        handleClick(index) {
            console.log('父组件方法被触发'+index);
            this.currentIndex = index;
        },
        handler(event) {
            console.log(event);
            this.showMask = true;
            let mask = this.$refs.mask;
            let big = this.$refs.big;
            let left = event.offsetX - mask.offsetWidth / 2;
            let top = event.offsetY - mask.offsetHeight / 2;
            //约束范围
            if (left <= 0) left = 0;
            if (left >= mask.offsetWidth) left = mask.offsetWidth;
            if (top <= 0) top = 0;
            if (top >= mask.offsetHeight) top = mask.offsetHeight;
            big.style.display = 'block !important;';
            mask.style.display = 'block';
            mask.style.left = left + "px";
            mask.style.top = top + "px";
            big.style.left = -2 * left + "px";
            big.style.top = -2 * top + "px";
         
            console.log(big);
        },
        handlerOver (event) {
            let mask = this.$refs.mask;
            let big = this.$refs.big;
            this.showMask = false;
            mask.style.display = 'none !important;';
            big.style.display = 'none !important;';
           
        },
        processedActivityItems() {
            return this.activeList.map(item => {
                return {
                    ...item,
                    isImage: item.detail.includes('<img')
                };
            });
        }
    }
};
</script>
<style lang="less" scoped>
    .home{
        height: 100%;
        width: 100%;
        background: #000;
    }
    .home .top-fix{
        width: 100%;
        height: 90px;
        line-height: 90px;
        color: #444;
        display: flex;
        align-items: center;
        justify-content: space-between;
        position: fixed;
        top: 0px;
        left: 0px;
        z-index: 1000;
        box-sizing: border-box;
        padding-left: 80px;
    }
    .home .top-fix .menu-list{
        display: flex;
        align-items: center;
        font-size: 28px;
        color: #000;
        height: 100%;
        padding-top: 40px;
        padding-right: 60px;
        cursor: pointer;
    }
    .cs{
        cursor: pointer;
    }
    .home .top-fix .white{
        color: #fff;
    }
    .home .top-fix .menu-list .act{
        font-size: 29px;
        font-weight: bold;
    }
    .home .top-fix .index{
        min-width: 180px;
        text-align: center;
    }
    .home .top-fix .logo{
        width: 200px;
        height: 100%;
        box-sizing: border-box;
        padding-top: 10px;
    }
    .home .top-fix .logo .img{
        width: 200px;
        height: 100px;
    }
    .content{
        width: 100%;
       
        position: fixed;
        top: 80px;
        left: 0px;
        bottom: 80px;
        z-index: 100;
    }
    .content .img{
        width: 100%;
        height: 100%;
    }
    .content .left-box{
        position: absolute;
        top: 54px;
        left: 80px;
        height: 835px;
        width: 28%;
        display: flex;
        box-sizing: border-box; 
        background-color: rgba(0, 0, 0, 0.2);
        /* border-right:2px solid #fff; 
        border-bottom:2px solid #fff;  */
        color: #fff;
        flex-direction: column;
        /* border-color: rgba(255, 255, 255, 0.4); */
    }
    .left-box .checkMore{
        position: absolute;
        left: -110px;
        bottom: 43px;
        font-size: 18px;
        color: #666;
        display: flex;
        align-items: center;
        width: 120%;
    }
    .left-box .checkMore .line-box{
        display: flex;
        align-items: center;
        width: 80%;
        margin-left: 8px;
    }
    .left-box .checkMore .radio{
        width: 8px;
        height: 8px;
        border-radius: 50%;
        border: 1px solid #e5e5e5;
    }
    .left-box .checkMore .line{
        height: 1px;
        background: #e5e5e5;
        width: 100%;
    }
    .content .left-box .title .title-sm{
        font-size: 24px;
        box-sizing: border-box;
        padding-top: 45px;
        padding-left:70px;
    }
    .content .left-box .title .title-big{
        font-size: 60px;
        height: 121px;
        line-height: 121px;
        padding-left: 44px;
    }
    .content .right-box{
        position: absolute;
        top: 54px;
        right: 80px;
        height: 835px;
        width: 62%;
        display: flex;
        box-sizing: border-box; 
        background-color: rgba(0, 0, 0, 0.2);
        /* border-right:2px solid #fff; 
        border-bottom:2px solid #fff;  */
        color: #fff;
        flex-direction: column;
        display: flex;
        align-items: center;
        box-sizing: border-box;
        padding: 20px;
    }
    .content .right-box .video{
        width: 100%;
        height: 100%;
    }
    .content .public{
        position: absolute;
        top: 54px;
        left: 80px;
        right: 80px;
        height: 835px;
        display: flex;
        box-sizing: border-box; 
        background-color: rgba(0, 0, 0, 0.2);
        /* border-right:2px solid #fff; 
        border-bottom:2px solid #fff;  */
        color: #fff;
        flex-direction: column;
        display: flex;
        align-items: center;
        box-sizing: border-box;
        padding: 20px;
    }
    .public-tab{
        display: flex;
        align-items: center;
        height: 60px;
        line-height: 60px;
        width: 100%;
    }
    .public-tab-item{
        font-size: 30px;
        color: #fff;
        box-sizing: border-box;
        padding: 0px 45px;
        height: 60px;
        line-height: 60px;
        position: relative;
    }
    .public-tab-item .botLine{
        width: 65%;
        height: 3px;
        background: #fff;
        position: absolute;
        bottom: -3px;
        left: 50%;
        transform: translate(-50%,0);
    }
    .public-tab-item .text{
        width: 100%;
        height: 60px;
        line-height: 60px;
    }
    .public-tab-item .text-act{
        /* border-bottom: 1px solid #fff; */
    }
    .public-detail{
        box-sizing: border-box;
        padding: 0 35px 0 45px; 
        flex-direction: column;
        height: 775px;
        overflow-y: auto;
        width: 100%;
    }
    .honor-box{
        box-sizing: border-box;
        padding: 0 35px 0 45px; 
        flex-direction: column;
        height: 775px;
        overflow-y: auto;
        width: 100%;
    }
    .honor-box .img-box{
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        box-sizing: border-box;
        padding: 25px 0;
        justify-content: space-between;
    }
    .honor-box .img-box .img{
        width:18%;
        height: 144px;
        margin-bottom: 25px;
        margin-right: 35px;
    }
    .honor-box .img-box .img:nth-child(5n){
        margin-right: 0px;
    }
    .public-detail .public-detail-item{
        height: 180px;
        width: 100%;
        border-bottom: 1px solid #e5e5e5;
        box-sizing: border-box;
        padding: 15px 0;
        display: flex;
        position: relative;
    }
    .public-detail .public-detail-item .time{
        position: absolute;
        right: 25px;
        top: 24px;
        font-size: 18px;
        font-weight: bold;
        color: #fff;
    }
    .public-detail .public-detail-item .img{
        width: 200px;
        height: 100%;
        margin-right: 10px;
    }
    .public-detail .public-detail-item .text-detail{
        display: flex;
        flex-direction: column;
        box-sizing: border-box;
        padding: 8px 0;
        width: 85%;
    }
    .public-detail .public-detail-item .text-detail .text-detail-title{
        font-size: 24px;
        font-weight: bold;
    }
    .public-detail .public-detail-item .text-detail .text-detail-content{
        font-size: 18px;
        color: #fff;
        margin-top: 25px;
        line-height: 28px;
        display:-webkit-box;
        -webkit-box-orient:vertical;
        -webkit-line-clamp:2;    /* 根据业务需求设置第几行显示省略号 */
        overflow:hidden;
    }
    .content .left-footer{
        position: absolute;
        left: 35px;
        top: 50%;
        transform: translate(-50%,-50%);
        width: 14px;
        margin: 0 auto;
        line-height: 28px;
        font-size: 16px;
        word-wrap: break-word;
        color: #fff;
        text-align: center;
        display: flex;
        flex-direction: column;
    }
    .content .left-footer .text{
        letter-spacing:4px;
        writing-mode: vertical-rl;
    }
    .content .left-footer .num{
        letter-spacing:4px;
        line-height: 22px;
    }
    .content .left-footer .line-box{
        display: flex;
        align-items: center;
        justify-content: center;
        margin: 25px 0px;
        width: 100%;
    }
    .content .left-footer .line-box .line{
        width: 2px;
        height: 80px;
        background: #fff;
    }
    .center-box{
        position: absolute;
        top: 50%;
        transform: translate(0%,-50%);
        width: 100%;
        display: flex; 
        align-items: center;
        padding-left: 80px;
        padding-right: 80px;
    }
    .center-box .center-left{
        width: 606px;
        box-sizing: border-box;
        padding-left: 118px;
        padding-right: 102px;
        height: 485px;
        margin-right: 42px;
        background-color: rgba(0, 0, 0, 0.2);
    }
    .content .center-box .title .title-sm{
        font-size: 24px;
        box-sizing: border-box;
        padding-top: 0px;
        padding-left:70px;
        color: #fff;
        text-align: right;
        display: none;
    }
    .content .center-box .title .title-big{
        font-size: 60px;
        color: #fff;
        text-align: center;
        margin-top: 32px;
        font-weight: bold;
    }
    .center-box .center-left .btn-list{
        display: flex;
        align-items: flex-end;
        justify-content: center;
        flex-direction: column;
        margin-top:24px; 
    }
    .center-box .center-left .btn-list .btn-item{
        width: 100%;
        height: 80px;
        line-height: 80px;
        color: #000;
        text-align: center;
        font-size: 28px;
        margin-bottom: 18px;
        border-radius: 2px;
        background: #fff;
    }
    .center-box .center-left .btn-list .act{
        color: #000;
        background: #44D7B6 ;
    }
    .center-box .center-right{
        width: 1190px;
        height: 750px;
        box-sizing: border-box;
        padding: 15px 30px;
        background-color: rgba(0, 0, 0, 0.2);
        position: relative;
    }
    .center-box .center-right .checkMore{
        position: absolute;
        right: -780px;
        bottom: 43px;
        font-size: 18px;
        color: #666;
        display: flex;
        align-items: center;
        width: 100%;
    }
    .center-box .center-right .checkMore .line-box{
        display: flex;
        align-items: center;
        width: 80%;
        margin-left: 8px;
    }
    .center-box .center-right .checkMore .radio{
        width: 8px;
        height: 8px;
        border-radius: 50%;
        border: 1px solid #e5e5e5;
    }
    .center-box .center-right .checkMore .line{
        height: 1px;
        background: #e5e5e5;
        width: 100%;
    }
    .center-box .center-right .center-right-list{
        display: flex;
        flex-direction: column;
        width: 100%;
        height: 100%;
        color: #fff;
        overflow-y: auto;
    }
    .center-box .center-right .center-right-list .list-item{
        display: flex;
        box-sizing: border-box;
        padding: 8px 0px;
        border-bottom: 2px solid #fff;
        height: 230px;
        border-color: rgba(255, 255, 255, 0.4);
        align-items: center;
        justify-content: center;
    }
    .center-box .center-right .center-right-list .list-item .img{
        height:168px;
        width: 280px;
        border-radius: 8px;
    }
    .center-box .center-right .center-right-list .list-item .text-value{
        width: 70%;
        display: flex;
        flex-direction: column;
        box-sizing: border-box;
        padding-left: 25px;
        height: 175px;
    }
    .center-box .center-right .center-right-list .list-item .text-value .text-title{
        display: flex;
        align-items: center;
        justify-content: space-between;
        height:40px;
        font-size: 22px;
        line-height: 40px;
    }
    .center-box .center-right .center-right-list .list-item .text-value .text-title .name{
        font-size: 22px;
        color: #fff;
        overflow: hidden; 
        text-overflow: ellipsis; 
        white-space: nowrap;  
        width: 600px;
    }
    .center-box .center-right .center-right-list .list-item .text-value .text-title .time{
        font-size: 18px;
        color: #666;
    }
    .center-box .center-right .center-right-list .list-item .text-value .text-detail{
        overflow:hidden;
        display:-webkit-box;
        -webkit-box-orient:vertical;
        -webkit-line-clamp:3;    /* 根据业务需求设置第几行显示省略号 */
        margin: auto 0;
    }
    .center-box .center-right .center-right-list .list-item .text-value .text-detail p{
        font-size: 18px;
        line-height: 37px;
        color: #fff;
        box-sizing: border-box;
        padding-top: 14px;
    }
    .center-box-detail{
        width: 1190px;
        height: 750px;
        background-color: rgba(0, 0, 0, 0.2);
        box-sizing: border-box;
        padding: 30px 40px 32px 40px;
        font-size: 22px;
        color: #fff;
    }
    .center-box-detail .title{
        text-align: center;
        line-height: 48px;
        font-size: 26px;
        position: relative;
        padding-left: 80px;
        box-sizing: border-box;
        /* font-weight: bold; */
    }
    .center-box-detail .title .left-return{
        position: absolute;
        left: 0px;
        top: 50%;
        transform: translate(0,-50%);
        color: #fff;
        font-size: 20px;
        display: flex;
        align-items: center;
    }
    .center-box-detail .title .left-return .img{
        width: 28px;
        height: 28px;
        margin-right: 12px;
    }
    .center-box-detail .time{
        text-align: center;
        font-size: 18px;
        color: #999;
        line-height: 40px;
        padding-left: 80px;
        box-sizing: border-box;
    }
    .center-box-detail .text-msg{
        font-size: 22px;
        line-height: 42px;
        margin-top: 12px;
    }
    .center-box-detail .text-msg2{
        font-size:18px;
        line-height: 28px;
    }
    /* 游客服务 */
    .center-box2{
        position: absolute;
        top: 50%;
        transform: translate(0%,-50%);
        width: 100%;
        display: flex; 
        align-items: center;
        justify-content: space-between;
        box-sizing: border-box;
        padding-right: 80px;
        padding-left: 80px;
    }
    .center-box2 .center-right{
        width: 65%;
        height: 756px;
        background-color: rgba(0, 0, 0, 0.2);
    }
    .center-box2 .center-left{
        width: 33%;
        background-color: rgba(0, 0, 0, 0.2);
        height: 756px;
    }
    .center-box2 .center-right .title-box{
        width: 100%;
        display: flex;
        align-items: center;
        box-sizing: border-box;
        padding: 32px 0 24px 30px;
        height: 100px;
        box-sizing: border-box;
    }
    .center-box2 .center-right .title-box .title{
        font-size: 60px;
        font-weight: bold;
        color: #fff;
        margin-right: 40px;

    }
    .center-box2 .center-right .title-box .tab-box{
        display: flex;
        align-items: center;
    }
    .center-box2 .center-right .title-box .tab-box .tab-item{
        width: 200px;
        text-align: center;
        font-size: 32px;
        color: #e5e5e5;
        position: relative;
    }
    .center-box2 .center-right .title-box .tab-box .tab-item-act{
        color: #fff;
    }
    .center-box2 .center-right .title-box .tab-box .tab-item-act .botLine{
        width: 70%;
        height: 3px;
        background: #fff;
        position: absolute;
        bottom: -15px;
        left: 50%;
        transform: translate(-50%,0);
    }
    .center-box2 .center-right .detail-box {
        display: flex;
        justify-content: center;
        box-sizing: border-box;
        padding: 0 32px;
        height: calc(100% - 110px);
    }
    .center-box2 .center-right .detail-box .big-img-box{
        width: 100%;
        height: 100%;
        position: relative;
    }
    .center-box2 .center-right .detail-box .big-img-box .event {
        width: 100%;
        height: 100%;
        position: absolute;
        top: 0;
        left: 0;
        z-index: 9980;
    }
    .center-box2 .center-right .detail-box .big-img-box .img{
        width: 100%;
        height: 100%; 
    }
    .mask {
        width: 50%;
        height: 50%;
        background-color: rgba(171, 250, 171, 0.3);
        position: absolute;
        left: 0;
        top: 0;
        display: none;
   }

   .big {
    width: 100%;
    height: 100%;
    position: absolute;
    top: -1px;
    left: 100%;
    right: 0px;
    border: 1px solid #aaa;
    overflow: hidden;
    z-index: 998;
    display: none;
    background: white;
  }
  .center-box2 .center-right .detail-box .big-img-box .big img {
      width: 200%;
      max-width: 200%;
      height: 200%;
      position: absolute;
      left: 0;
      top: 0;
    }
    .big-img-box:hover .mask {
            display: block;
    }
    .big-img-box:hover  .big {
            display: block;
   }
    
    .center-box2 .center-right .detail-box .img-box {
        position: relative;
    }
    .center-box2 .center-right .detail-box .img-box .tab-head{
        position: absolute;
        transform: translate(-50%,0);
        left: 50%;
        width: 422px;
        height: 51px;
        background: #999;
        color: #000;
        display: flex;
        border-radius: 50px;
        align-items: center;
        box-sizing: border-box;
        padding-left: 2px;
        padding-right: 2px;
        top:10px;
    }
    .center-box2 .center-right .detail-box .img-box .tab-head .tab-item{
        flex: 1;
        height: 46px;
        line-height: 46px;
        font-size: 24px;
        text-align: center;
    }
    .center-box2 .center-right .detail-box .img-box .tab-head .tab-item-act{
        background: #fff;
        border-radius: 50px;
    }
    .center-box2 .center-right .detail-box .img-box .img{
        width: 486px;
        height: 608px;
        border-radius: 20px;
    }
    .center-box2 .center-right .detail-box .text-box{
        width: 646px;
        height: 100%;
        font-size: 26px;
        color: #e5e5e5;
        margin-left: 33px;
        line-height:32px;
        overflow-y: hidden;
        text-overflow:ellipsis;
  
    }
    .center-box2 .guaide{
        font-size: 18px;
        line-height: 44px;
        color: #fff;
    }
    .center-box2 .guaide .item{
        line-height: 32px;
    }
    .center-box2 .guaide .em{
        text-indent: 2em;
    }
    .center-box2 .ticket-list{
        display: flex;
        flex-direction: column;
        box-sizing: border-box;
        padding: 0 33px;
    }
    .center-box2 .ticket-list-item{
        width: 100%;
        box-sizing: border-box;
        padding: 33px 0px;
        display: flex;
        border-bottom: 1px solid #e5e5e5;
    }
    .center-box2 .ticket-list-item .img1{
        width: 282px;
        height: 168px;
        border-radius: 16px;
        background: #44D7B6;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        color: #fff;
        font-size: 40px;
    }
    .center-box2 .ticket-list-item .img2{
        width: 282px;
        height: 168px;
        border-radius: 16px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        background: #0091FF;
        color: #fff;
        font-size: 40px;
    }
    .center-box2 .ticket-list-item .img1 .img{
        width: 76px;
        height: 76px;
        margin-bottom:5px;
    }
    .center-box2 .ticket-list-item .img2 .img{
        width: 80px;
        height: 80px;
        margin-bottom:5px;
    }
    .center-box2 .ticket-list-item .list-text-box{
        width: 836px;
        display: flex;
        flex-direction: column;
        box-sizing: border-box;
        padding: 0 12px;
        color: #fff;
    }
    .center-box2 .ticket-list-item .list-text-box .text1{
        font-size: 24px;
        margin-bottom: 14px;
    }
    .center-box2 .ticket-list-item .list-text-box .text2{
        font-size: 20px;
        line-height: 37px;
    }
    .center-box2 .center-left{
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 40px;
        color: #fff;
        flex-direction: column;
    }
    .center-box2 .center-left .code-img{
        width: 300px;
        height: 300px;
        margin-bottom: 27px;
    }
    .center-box2  .ewm-box{
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        font-size: 20px;
        margin-bottom: 38px;
    }
    .center-box2  .ewm-box .ewm{
        width: 230px;
        height: 230px;
        margin-bottom: 25px;
    }
    .center-box2  .btn{
        width: 402px;
        height: 120px;
        background: #03C599;
        border-radius: 80px;
        line-height: 120px;
        text-align: center;
        font-size: 40px;
        color: #fff; 
        margin-top: 50px;
    }
    .detail{
        display: flex;
        flex-direction: column;
        box-sizing: border-box;
        padding-top: 0px;
        padding-left: 35px;
        padding-right: 35px;
    }
    .detail .detail-item{
        font-size: 19px;
        line-height: 37px;
        margin-top: 5px;
    }
    .detail .detail-item-img{
      width: 100%;
      height: 680px;
      overflow-y: auto; 
    }
    .img-detail{
      width: 100%;
    //   height: 200px;
    }
    .bot-box{
        width: 40%;
        height: 120px;
        line-height: 120px;
        color: #fff;
        display: flex;
        align-items: center;
        justify-content: space-between;
        position: fixed;
        bottom: 0px;
        right: 0px; 
        z-index: 1000;
        cursor: pointer;
        /* background-color: rgba(0, 0, 0, 0.4) */
    }
    .bot-box .language{
        flex: 0.7;
        display: flex;
        align-items: center;
        font-size: 20px; 
        color: #666;
        padding-right: 20px;
        cursor: pointer;
    }
    .bot-box .language .item{
        flex: 1;    
        box-sizing: border-box;
        padding: 0 20px;
        text-align: center;
        white-space:nowrap; 
    }
    .bot-box .language  .act{
        color: #fff;
    }
    .bn{
        border: none !important;
    }

    .center-right-title{
        font-size: 33px;
        font-weight: bold;
        text-align: center;
        line-height: 100px;
    }
    .center-right-detail{
        font-size: 24px;
        line-height: 40px;
    }




      /* 控制圆点 */
    .banner-circle{
        position: fixed;
        bottom: 45px;
        width: 100%;
        height: 20px;
        z-index: 10000;
    }
    .banner-circle ul{
        margin: 0 50px;
        height: 100%;
        text-align: center;
    }
    .banner-circle ul li{
        display: inline-block;
        width: 16px;
        height: 16px;
        margin: 0 24px;
        border-radius: 50%;
        background-color: #ffffff;
        cursor: pointer;
    }
    .active{
        border: 2px solid #44D7B6;
    }




    .table-box{
        box-sizing: border-box;
        padding: 0 75px 0 15px;
    }
    .table{
        display: flex;
        flex-direction: column;
        align-items: center;
        color: #fff;
        border: 1px solid #e5e5e5;
        border-radius: 4px;
    }
    .table .table-item{
        display: flex;
        align-items: center;
        width: 100%;
    }
    .table .table-item2{
        display: flex;
        align-items: center;
        width: 100%;
    }
    .table .br{
        border-right: 1px solid #e5e5e5;
    }
    .table .bb{
        border-bottom: 1px solid #e5e5e5;
    }
    .table .table-item .name{
        width: 25%;
        height: 90px;
        font-size: 28px;
        font-weight: bold;
        line-height: 90px;
        text-align: center;
    }
    .table .table-item .type{
        width: 15%;
        height: 90px;
        font-size: 28px;
        font-weight: bold;
        line-height: 90px;
        text-align: center;
    }
    .table .table-item .price{
        width: 25%;
        height: 90px;
        font-size: 28px;
        font-weight: bold;
        line-height: 90px;
        text-align: center;
    }
    .table .table-item .common{
        width: 35%;
        height: 90px;
        font-size: 28px;
        font-weight: bold;
        line-height: 90px;
        text-align: center;
    }
    .table .table-item2 .name{
        width: 25%;
        height: 180px;
        font-size: 26px;
        text-align: center;
        display: flex;
        align-items: center;
        justify-content: center;
        box-sizing: border-box;
        padding: 0 60px;
    }
    .l32{
        line-height: 32px;
    }
    .table .table-item2 .type{
        width: 15%;
        height: 180px;
        font-size: 26px;
        text-align: center;
        display: flex;
        flex-direction: column;
        align-items: center;
    }
    .table .table-item2 .type .type-item{
        flex: 1;
        line-height: 90px;
        text-align: center;
        width: 100%;
    }
    .table .table-item2 .price{
        width: 25%;
        height: 180px;
        font-size: 26px;
        text-align: center;
        display: flex;
        flex-direction: column;
        align-items: center;
    }
    .table .table-item2 .price .price-item{
        flex: 1;
        line-height: 90px;
        text-align: center;
        width: 100%;
    }
    .table .table-item2 .common{
        width: 35%;
        height: 180px;
        font-size: 26px;
        text-align: center;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        box-sizing: border-box;
        padding: 0 45px;
    }
    .notice .notice-title{
        font-size: 22px;
        font-weight: bold;
        line-height: 40px;
    }
    .notice{
        font-size: 16px;
        color: #fff;
    }
    .notice .l30{
        line-height: 25px;
    }

    .prefer-box{
        box-sizing: border-box;
        padding: 25px 20px;
        font-size: 22px;
        color: #fff;
    }
    .prefer-box .l38{
        line-height: 40px;
    }
    .rule-box{
        box-sizing: border-box;
        padding: 25px 20px;
        font-size: 22px;
        color: #fff;
    }
    .rule-box .l38{
        line-height: 38px;
    }
    .center-box-detail .img-box{
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        box-sizing: border-box;
        padding: 25px 0;
    }
    .center-box-detail .img-box .img{
        width:250px;
        height: 150px;
        margin-right:45px; 
    }


    .publicDetail .title{
        margin-top: 35px;
        text-align: center;
        line-height: 48px;
        font-size: 26px;
        position: relative;
        /* font-weight: bold; */
    }
    .publicDetail .title .left-return{
        position: absolute;
        left: 0px;
        top: 50%;
        transform: translate(0,-50%);
        color: #fff;
        font-size: 20px;
        display: flex;
        align-items: center;
    }
    .publicDetail .title .left-return .img{
        width: 28px;
        height: 28px;
        margin-right: 12px;
    }
    .publicDetail .time{
        text-align: center;
        font-size: 18px;
        color: #999;
        line-height: 30px;
    }
    .publicDetail .text-msg{
        font-size: 22px;
        line-height: 42px;
        margin-top: 12px;
    }
    .time{
        color: #fff !important;
        min-width: 200px;
    }
    .w11{
        width: 1112px !important;
    }
    .publicDetail-img{
        display: flex;
        align-items: center;
        justify-content: center;
  
    }
    .publicDetail-img .img{
        width: 500px;
        height: 700px;
    }
    .scroll-box {
        max-height: 600px; /* 你可以根据需要设置一个合适的最大高度 */
        overflow-y: scroll; /* 当内容超出时显示垂直滚动条 */
    }
    .iframe-container {
  display: flex;
  justify-content: center; /* 水平居中 */
  align-items: center;    /* 垂直居中 */
  height: 100vh;           /* 使容器占满整个视口高度，根据需要调整 */
  border: 1px solid #ccc;  /* 可选：为容器添加边框以便于观察效果 */

  .scrollable-container {
  max-height: 150px; /* 设置容器最大高度 */
  overflow-y: auto; /* 启用垂直滚动条 */
  border: 1px solid #ccc;
}
.iframe-container {
    position: relative; /* 父容器设置为相对定位 */
    width: 100%; /* 宽度占满父容器 */
    height: 400px; /* 高度根据需要设置 */
}

.iframe-container iframe {
    position: absolute; /* iframe设置为绝对定位 */
    top: 50%; /* 垂直居中 */
    left: 50%; /* 水平居中 */
    transform: translate(-50%, -50%); /* 调整位置 */
    width: 100%; /* 宽度占满父容器 */
    height: 100%; /* 高度占满父容器 */
}
}
</style>
